import {
  WbCard,
  WbCardContent,
  WbTruncatedTypographyWrapper,
  WbVerticalTabs,
} from '@agilelab/plugin-wb-platform';
import { FC, useCallback, useMemo } from 'react';
import { TeamRoleEnum } from '@agilelab/plugin-wb-team-roles-common';
import { useTeamRolesPanelContext } from '../../../context';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const DISABLED_TOOLTIP =
  'Onboard this project to be able to manage other Team Roles.';

export const TeamRolesCard: FC = () => {
  const { setSelectedTeamRole, hasPrincipalOwner, enabledTeamRoles } =
    useTeamRolesPanelContext();

  const checkIfDisabled = useCallback(
    (role: TeamRoleEnum) => !hasPrincipalOwner && role !== TeamRoleEnum.OWNER,
    [hasPrincipalOwner],
  );

  const onValueChange = useCallback(
    (value: number) => {
      setSelectedTeamRole(enabledTeamRoles[value].name);
    },
    [setSelectedTeamRole, enabledTeamRoles],
  );

  const tabs = useMemo(
    () =>
      enabledTeamRoles.map((role, index) => ({
        label: (
          <WbTruncatedTypographyWrapper
            maxLines={1}
            breakAll
            value={role.displayName}
            enableTooltip={false}
          />
        ),
        value: index,
        icon: <InfoOutlinedIcon />,
        disabled: checkIfDisabled(role.name),
        tooltip: checkIfDisabled(role.name)
          ? DISABLED_TOOLTIP
          : role.description,
      })),
    [enabledTeamRoles, checkIfDisabled],
  );

  return (
    <WbCard
      title="Team Roles"
      cardStyle={{ height: '100%', overflow: 'hidden' }}
    >
      <WbCardContent
        style={{
          height: '100%',
          padding: 8,
        }}
      >
        <WbVerticalTabs
          tabs={tabs}
          onValueChange={onValueChange}
          aria-label="Team Roles Tabs"
        />
      </WbCardContent>
    </WbCard>
  );
};
